import React from "react";
import { Button, Message, Typography } from "@arco-design/web-react";
import { IconCopy } from "@arco-design/web-react/icon";
import { useAuth0 } from "@auth0/auth0-react";
import { FetchApi } from "../Api/AuthenticatedApi";
import { buildEmbedSnippet } from "./embedSnippet";

const { Text } = Typography;

// Shows the copy-paste <script> embed code for this campaign's signup form. The
// org hash comes from settings; the base URL is a deployment fact served by
// /api/config (the UI's own origin is the wrong answer — it isn't the API).
export default function EmbedSnippetCard({ campaignId }) {
  const { getAccessTokenSilently } = useAuth0();
  const [orgHash, setOrgHash] = React.useState("");
  const [baseUrl, setBaseUrl] = React.useState("");

  React.useEffect(() => {
    FetchApi(
      getAccessTokenSilently,
      "/api/settings/organization",
      (org) => setOrgHash((org && org.org_hash) || ""),
      () => {},
      () => {}
    );
    FetchApi(
      getAccessTokenSilently,
      "/api/config",
      (cfg) => setBaseUrl((cfg && cfg.public_base_url) || ""),
      () => {},
      () => {}
    );
  }, [getAccessTokenSilently]);

  const snippet = buildEmbedSnippet(baseUrl, orgHash, campaignId);

  const copy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(snippet).then(
        () => Message.success("Embed code copied"),
        () => Message.error("Couldn't copy to clipboard")
      );
    } else {
      Message.info(snippet);
    }
  };

  if (!snippet) {
    if (campaignId && orgHash && !baseUrl) {
      return (
        <Text type="secondary">
          Set PUBLIC_BASE_URL on the server to generate this campaign’s embed code.
        </Text>
      );
    }
    return <Text type="secondary">Save the campaign first to get its embed code.</Text>;
  }

  return (
    <div>
      <Text type="secondary" style={{ fontSize: 12 }}>
        Paste this on any website to embed this campaign’s signup form:
      </Text>
      <div style={{ display: "flex", gap: 8, marginTop: 8, alignItems: "stretch" }}>
        <pre
          style={{
            flexGrow: 1,
            margin: 0,
            padding: "8px 12px",
            background: "var(--color-fill-2)",
            borderRadius: 4,
            overflow: "auto",
            fontSize: 12,
          }}
        >
          {snippet}
        </pre>
        <Button icon={<IconCopy />} onClick={copy}>
          Copy
        </Button>
      </div>
    </div>
  );
}
